import React, { useEffect, useCallback } from 'react';
import { Grid, Slide } from '@mui/material';
import { isUndefined, isEqual } from 'underscore';
import { useDispatch, useSelector } from 'react-redux';

import { TerritoryList } from './TerritoryList/TerritoryList';
import TerritoryDetail from './TerritoryDetail';
import { TerritoryMap } from './TerritoryMap';

import { getTerritories } from '@/actions/territories/thunks';
import { setSelectedTerritory, setTerritories, setTerritoryColors, setRequest } from '@/actions/territories/pure';
import { SET_TERRITORY_REQUEST } from '@/actions/types';
import { toggleLoading } from '@/actions/common/commonPure';
import { RootState } from '@/index';

const PAGE_SIZE = 100;

function Territories() {
  const dispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.core?.loading ?? false, isEqual);
  const selected_territory = useSelector((state: RootState) => state.territories?.selected_territory, isEqual);
  const setLoading = useCallback((val: boolean) => dispatch(toggleLoading(val)), [dispatch]);
  const onSelectTerritory = useCallback((t: any) => dispatch(setSelectedTerritory(t)), [dispatch]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await dispatch(getTerritories(false, PAGE_SIZE) as any);
      setLoading(false);
    })();

    return () => {
      onSelectTerritory(undefined);
      dispatch(setTerritoryColors({}));
      dispatch(setTerritories([]));
      dispatch(
        setRequest(
          {
            page: 0,
            num_results: 0,
            total_pages: 1,
            results_per_page: PAGE_SIZE,
          },
          SET_TERRITORY_REQUEST
        )
      );
    };
  }, [dispatch, onSelectTerritory, setLoading]);

  return (
    <Grid container sx={{ p: 2, width: '100%', overflowX: 'hidden' }}>
      {!selected_territory && !loading && (
        <Slide direction="right" in timeout={{ enter: 300, exit: 300 }}>
          <Grid item xs={5}>
            <TerritoryList selected={selected_territory} onMerge={() => null} />
          </Grid>
        </Slide>
      )}

      {selected_territory && (
        <Slide direction="left" in={Boolean(!isUndefined(selected_territory))} timeout={{ enter: 100, exit: 100 }}>
          <Grid item xs={5}>
            <TerritoryDetail />
          </Grid>
        </Slide>
      )}

      <Grid item xs={7} sx={{ pr: 2 }}>
        <TerritoryMap />
      </Grid>
    </Grid>
  );
}

export default Territories;
